/** Feed 卡片多元 outcome：默认外露个数（超过 FULL_DISPLAY_MAX 时仅展示前 N 个） */
export const MULTI_CARD_PREVIEW_COUNT = 4;

/** Feed 卡片多元：不超过该数量时展示全部 outcome 按钮 */
export const MULTI_CARD_FULL_DISPLAY_MAX = 4;

/** 多 markets 集合列表卡：精选多元子 market 时最多展示 outcome 数 */
export const MULTI_COLLECTION_CARD_OUTCOME_MAX = 3;

/** 多元 outcome UI：按钮色调（与卡片环同色同序，按 API outcomes 顺序） */
export const MULTI_OUTCOME_TONES = ['yes', 'no', 'draw', 'home', 'away', 'violet', 'amber'];

/** 与 _pm-outcome.scss / CSS 变量一致的 hex */
export const MULTI_OUTCOME_TONE_COLORS = {
  yes: '#2563eb',
  no: '#e05252',
  draw: '#64748b',
  home: '#2563eb',
  away: '#e05252',
  violet: '#9333ea',
  amber: '#f59e0b',
};

/** @param {number} index */
export function multiOutcomeToneAt(index) {
  return MULTI_OUTCOME_TONES[Number(index) % MULTI_OUTCOME_TONES.length];
}

/** @param {number} index */
export function multiOutcomeColorAt(index) {
  const tone = multiOutcomeToneAt(index);
  return MULTI_OUTCOME_TONE_COLORS[tone] || '#64748b';
}

/** @param {{ tone?: string } | null | undefined} opt @param {number} index */
export function multiOutcomeToneClass(opt, index = 0) {
  const tone = String(opt?.tone || multiOutcomeToneAt(index)).trim();
  return `pm-outcome__btn--${tone}`;
}

/** Feed 卡片多元按钮：与二元 yes-soft / no-soft 同款的浅色样式 */
export function multiOutcomeToneSoftClass(opt, index = 0) {
  const tone = String(opt?.tone || multiOutcomeToneAt(index)).trim();
  return `pm-outcome__btn--${tone}-soft`;
}

/**
 * Feed 卡片多元按钮色调：首=是(绿)、尾=否(红)、中间=灰（与二元 Yes/No 一致）
 * @param {number} total 当前展示的 outcome 个数
 */
export function multiOutcomeCardSoftClass(opt, index = 0, total = 0) {
  const n = Number(total) || 0;
  const i = Number(index) || 0;
  if (n >= 3) {
    if (i === 0) return 'pm-outcome__btn--yes-soft';
    if (i === n - 1) return 'pm-outcome__btn--no-soft';
    return 'pm-outcome__btn--draw-soft';
  }
  return multiOutcomeToneSoftClass(opt, i);
}

/**
 * 多元 outcome 按钮网格 modifier
 * - 2：两列
 * - 3：两列，第三个占满第二行
 * - 4：2×2
 * - 5+：三列多行（5 = 3+2，6 = 3+3 …）
 * @param {number} count
 */
export function multiOutcomeGridClass(count) {
  const n = Number(count) || 0;
  if (n >= 5) return 'pm-outcome__btns--5';
  if (n === 4) return 'pm-outcome__btns--4';
  if (n === 3) return 'pm-outcome__btns--3';
  return '';
}

/** Feed 卡片统一高度（对齐 PM 网格约 180） */
export const PC_MARKET_CARD_UNIFIED_HEIGHT = 180;
export const H5_MARKET_CARD_UNIFIED_HEIGHT = 172;

/** 卡片 body 高度估算（px，虚拟列表 legacy） */
export function estimateMultiOutcomeBody(count) {
  const n = Number(count) || 0;
  if (n >= 4) return 40 * 2 + 8;
  if (n === 3) return 40 * 2 + 8;
  return 44;
}

/**
 * 为卡片/详情补充 tone + color（与 API outcomes 顺序一致，不排序）
 * @param {Array<{ label?: string, percent?: number, outcome?: string, outcomePrice?: number }>} options
 */
export function enrichMultiOutcomeOptions(options) {
  return (Array.isArray(options) ? options : []).map((opt, i) => ({
    ...opt,
    tone: opt?.tone || multiOutcomeToneAt(i),
    color: opt?.color || multiOutcomeColorAt(i),
  }));
}

/**
 * 构建概率环分段 — 与下方 outcome 按钮同序、同色、同占比
 * @param {Array<{ label?: string, percent?: number, outcome?: string, tone?: string, color?: string }>} options
 */
export function buildMultiOutcomeRingSegments(options) {
  const opts = enrichMultiOutcomeOptions(options);
  if (opts.length < 2) return [];

  const percents = opts.map((o) => Math.max(0, Number(o?.percent) || 0));
  const sum = percents.reduce((a, b) => a + b, 0) || 1;

  return opts.map((o, i) => ({
    label: o?.label ?? o?.outcome,
    tone: o.tone,
    percent: percents[i],
    ratio: percents[i] / sum,
    color: o.color,
  }));
}
